module.exports = __webpack_public_path__ + "static/media/dong-lotto.4cdea759.png";